import { getStorage } from "hooks/useStorage";
import { ReactComponent as FacebookIcon } from "assets/images/social/facebook.svg";
import { ReactComponent as InstagramIcon } from "assets/images/social/instagram.svg";
import styled, { css } from "styled-components";

interface SocialMediaProps {
  type: "primary" | "gradient" | "secondary";
  include?: string[];
}

const SocialMedia = (props: SocialMediaProps) => {
  const { type, include } = props;
  const socialLinks = getStorage("APP_OTHER.SOCIAL_LINKS");

  return (
    <SocialListWrapper>
      {(!include || include.includes("FACEBOOK")) && socialLinks.FACEBOOK && (
        <SocialItemWrapper type={type} href={socialLinks.FACEBOOK.LINK}>
          <StyledFacebookIcon type={type} />
        </SocialItemWrapper>
      )}

      {(!include || include.includes("INSTAGRAM")) && socialLinks.INSTAGRAM && (
        <SocialItemWrapper type={type} href={socialLinks.INSTAGRAM.LINK}>
          <StyledInstagramIcon type={type} />
        </SocialItemWrapper>
      )}
    </SocialListWrapper>
  );
};

const SocialListWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const SocialItemWrapper = styled.a<{
  type: "primary" | "gradient" | "secondary";
}>`
  width: 42px;
  height: 42px;
  border-radius: 8px;
  cursor: pointer;

  ${({ theme, type }) =>
    type === "secondary" &&
    css`
      background: ${theme.mode === 'dark' ? theme.palette.secondary.focused : theme.palette.secondary.disabled};

      &:hover {
        background: ${theme.palette.primary.main};
      }

      &:active {
        background: ${theme.palette.secondary.focused};
      }
    `}

  ${({ theme, type }) =>
    type === "primary" &&
    css`
      background: ${theme.palette.primary.main};

      &:hover {
        background: ${theme.palette.primary.hover};
      }

      &:active {
        background: ${theme.palette.primary.main};
      }
    `}

  ${({ theme, type }) =>
    type === "gradient" &&
    css`
      background: ${theme.palette.background.gradient};
    `}
`;

const StyledFacebookIcon = styled(FacebookIcon)<{
  type: "primary" | "gradient" | "secondary";
}>`
  ${({ theme, type }) =>
    type === "secondary" &&
    css`
      svg path {
        fill: ${theme.palette.text.main};
      }
    `}

  ${({ theme, type }) =>
    (type === "primary" || type === "gradient") &&
    css`
      path {
        fill: ${theme.palette.primary.black};
      }
    `}
`;

const StyledInstagramIcon = styled(InstagramIcon)<{
  type: "primary" | "gradient" | "secondary";
}>`
  ${({ theme, type }) =>
    type === "secondary" &&
    css`
      rect,
      circle {
        stroke: ${theme.palette.text.main};
      }

      circle:last-child {
        fill: ${theme.palette.text.main};
        stroke: transparent;
      }
    `}

  ${({ theme, type }) =>
    (type === "primary" || type === "gradient") &&
    css`
      rect,
      circle {
        stroke: ${theme.palette.text.second};
      }

      circle:last-child {
        fill: ${theme.palette.text.second};
        stroke: transparent;
      }
    `}
`;

export default SocialMedia;
